export default {
    state: [
        {short: "NSW", long: "NSW"},
        {short: "ACT", long: "ACT"},
        {short: "Vic", long: "Vic"},
        {short: "Qld", long: "Qld"},
        {short: "SA", long: "SA"},
        {short: "WA", long: "WA"},
        {short: "Tas", long: "Tas"},
        {short: "NT", long: "NT"}
    ],
    new_connection_type: [
        "New", "Port", "Upgrade/Resign", "Pre to Post"
    ],
    sim_type: [
        "eSIM", "Physical SIM"
    ],
    plan_name: [
        {
            name: "Vodafone Business Flex Voice Jan 2020",
            plans: ["$50 Business Flex TF 24M - AU12168", "$80 Business Flex TF 24M - AU12169", "$100 Business Flex TF 24M - AU12170", "$130 Business Flex TF 24M - AU12171"]
        },
        {
            name: "Vodafone Business Flex Voice SIMO Jan 2020",
            plans: ["$30 Business Flex SIMO 24M - AU12176", "$40 Business Flex SIMO 24M - AU12177", "$60 Business Flex SIMO 24M - AU12178"]
        }
    ],
    plan_term: [
        0, 12, 24, 36
    ],
    mpp_term: [
        12, 24, 36
    ],
    device_payment_method: [
        "Plan", "Tech Fund", "MPP", "Outright", "Partial"
    ]
}